import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  -webkit-box-align: end;
  align-items: end;
  gap: 16px;
  height: 100%;
`;
